module.exports = __webpack_public_path__ + "static/media/m_b_25.babc0d52.png";